;(function($, window, document){
    window.LoadMore = Me.view.extend({
        options: {
            isLoading: false
        },

        initialize: function() {
            _.bindAll(this, 'loadMore', 'loadMoreSuccessHandler', 'loadMoreErrorHandler');
            this.addEvents();
        },
        addEvents: function() {
            this.$el.on('click', this.loadMore);
        },
        loadMore: function(){
            if(this.options.isLoading){
                return;
            }

            this.options.isLoading = true;
            var view = this;

            this.$('.loader').removeClass('hide');

            var serviceUrl = '';
            var segmentedUrl = window.location.toString().split('/');

            if(!isNaN(parseInt(segmentedUrl[segmentedUrl.length -1]))){
                segmentedUrl = segmentedUrl.slice(0, -1);

                for(var index=0; index <= segmentedUrl.length-1; index++){
                    serviceUrl += segmentedUrl[index] + '/';
                }
            }else{
                serviceUrl = window.location + '/'
            }

            console.log(serviceUrl);
            $.ajax({
                method: 'GET',
                url: serviceUrl + $('.listing-sections').attr('data-nextpage'),
                success: view.loadMoreSuccessHandler,
                error: view.addToCartErrorHandler
            })
        },
        loadMoreSuccessHandler: function(e){
            this.$('.loader').addClass('hide');
            this.options.isLoading = false;
            Me.dispatch.emit('LOAD_MORE.SUCCESS', this, {data: $(e).find('.listing-sections')[0]});
        },
        loadMoreErrorHandler: function(e){
            this.$('.loader').addClass('hide');
            this.options.isLoading = false;
        }
    });
}(jQuery, window, document));
